// extracted by mini-css-extract-plugin
module.exports = {"base":"Section__base__34Cxm","displayBorder":"Section__displayBorder__DqG9Q","isBold":"Section__isBold__2Z8VI"};